var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserVoiceFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18433_14993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666664 14.6667C0.666664 13.2522 1.22857 11.8957 2.22876 10.8955C3.22896 9.89527 4.58551 9.33337 6 9.33337C7.41448 9.33337 8.77104 9.89527 9.77123 10.8955C10.7714 11.8957 11.3333 13.2522 11.3333 14.6667H0.666664ZM6 8.6667C3.79 8.6667 2 6.8767 2 4.6667C2 2.4567 3.79 0.666705 6 0.666705C8.21 0.666705 10 2.4567 10 4.6667C10 6.8767 8.21 8.6667 6 8.6667ZM12.164 2.12271C12.497 2.92948 12.6678 3.79393 12.6667 4.6667C12.6678 5.53948 12.497 6.40393 12.164 7.2107L11.046 6.39737C11.2368 5.84033 11.3339 5.25551 11.3333 4.6667C11.3341 4.07794 11.2372 3.49312 11.0467 2.93604L12.164 2.12271ZM14.3653 0.522705C15.0041 1.81059 15.3355 3.2291 15.3333 4.6667C15.3333 6.15537 14.9847 7.5627 14.3653 8.8107L13.2687 8.01337C13.7521 6.96401 14.0017 5.82208 14 4.6667C14 3.47204 13.738 2.33804 13.2687 1.32004L14.3653 0.522705Z",
    fill: "#3B79B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18433_14993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserVoiceFill);
export default __webpack_public_path__ + "static/media/user-voice-fill.39a80df1ff88c92788006a5194537bcf.svg";
export { ForwardRef as ReactComponent };